import * as React from 'react'
import { type FC } from 'react'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material'
import { useTranslation } from 'react-i18next'

interface SetCompanyAlarmConfirmDialogProps {
  isOpen: boolean
  onClose: () => void
  onConfirm: () => void
}

export const SetCompanyAlarmConfirmDialog: FC<SetCompanyAlarmConfirmDialogProps> = ({
  isOpen,
  onClose,
  onConfirm
}) => {
  const { t } = useTranslation()

  return (
        <Dialog open={isOpen} onClose={onClose} data-testid="set-company-alarm-confirm">
            <DialogTitle>
                {t('company_alarm_dialog.confirm_alarms_change')}
            </DialogTitle>
            <DialogContent>
                {t('company_alarm_dialog.are_you_sure_you_want_to_submit')}
            </DialogContent>
            <DialogActions>
                <Button color="secondary" onClick={onClose}>
                    {t('common.actions.back')}
                </Button>
                <Button color="primary" onClick={onConfirm}>
                    {t('common.actions.yes')}
                </Button>
            </DialogActions>
        </Dialog>
  )
}
